import React from 'react'

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-8">
          {/* Header */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white">
              Terms of Service
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Terms Content */}
          <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-8 shadow-sm">
            <div className="prose dark:prose-invert max-w-none">
              
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                1. Acceptance of Terms
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                By accessing and using the ineedcarbonbuckets service ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this Service.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                2. Service Description
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                The Service provides information about BMW M2, M3, M4, and M8 vehicles with carbon fiber bucket seats or individual paint available at dealerships. This information is aggregated from publicly available sources and is provided for informational purposes only.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                3. Disclaimer of Warranties
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                The information provided by our Service is on an "as is" basis. To the fullest extent permitted by law, Lunarware excludes all representations, warranties, and conditions relating to our Service and the use of this website.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                4. Data Accuracy
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                While we strive to provide accurate and up-to-date information, we cannot guarantee the accuracy, completeness, or timeliness of any data displayed. Vehicle availability, pricing, and specifications should always be verified directly with the dealership.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                5. Third-Party Services
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Our Service may contain links to third-party websites or services that are not owned or controlled by Lunarware. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                6. Limitation of Liability
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                In no event shall Lunarware, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                7. Intellectual Property
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                The Service and its original content, features, and functionality are and will remain the exclusive property of Lunarware and its licensors. The Service is protected by copyright, trademark, and other laws. BMW, M2, M3, M4, and M8 and related trademarks are property of BMW AG.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                8. Privacy Policy
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Your privacy is important to us. We do not collect personal information unless voluntarily provided through contact forms. We may use cookies and similar technologies to improve user experience.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                9. Modifications to Terms
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                10. Termination
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                We may terminate or suspend your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                11. Governing Law
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                These Terms shall be interpreted and governed by the laws of the jurisdiction in which Lunarware operates, without regard to its conflict of law provisions.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                12. Contact Information
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                If you have any questions about these Terms of Service, please contact us at:
                <br />
                <a href="mailto:caiotagb@gmail.com" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300">
                caiotagb@gmail.com
                </a>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Terms 